import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import NodeAPI from '../api';
import { pushSupported, subscribeDevice } from '../utils/pushSubscription';
// Reconcile a previously permitted device after subscription rotation or login.
// This never requests permission from a user whose permission is still default.
export default function PushSubscriptionSync() {
  const { user } = useAuth();
  useEffect(() => {
    if (!user || !pushSupported() || Notification.permission !== 'granted' ||
      localStorage.getItem('quizPushDeviceDisabled') === '1') return;
    let cancelled = false;
    NodeAPI.get('/quiz/notifications/preferences').then(({ data }) => {
      if (!cancelled && data.enabled) return subscribeDevice({ requestPermission: false });
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [user]);
  return null;
}
